export default function CsharpNamedArguments() {
  return (
    <h2>Csharp Named Arguments</h2>
  );
}
